import './App.css';
import Router from "./routers/router";
import Container from "./component/container";
import {observer} from "mobx-react-lite";
import {useStore} from "./hook/useStore";
import React, {useEffect, useState} from "react";
import {getCookies} from "./utils/getCookies";
import {useLocation, useNavigate} from "react-router-dom";
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {Box, Modal, Skeleton, Typography} from "@mui/material";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TableServices from "./store/srvices/table.services";
import { setLanguage } from './localization';
import AppModal from "./component/modal/AppModal";
import NoEdit from "./component/modal/modals/NoEdit";
import {stompClient} from './socket';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const App = observer(() => {
    const {auth} = useStore()
    const {noEdit} = useStore();
    const { t } = useTranslation()

    const [searchParams] = useSearchParams();
    const lang = searchParams.get('lang')
    const navigate = useNavigate()
    const location = useLocation()
    const locationHash = location?.search?.split('=')
    const isHaveHash = locationHash.length === 2 && locationHash[0] === '?app'
    const [version, setVersion] = useState("")

    useEffect(() => {
        if (!auth.loading && !auth.hash_error.isError) {
            stompClient.activate();

            stompClient.onConnect = () => {
                console.log('STOMP connected');

                stompClient.subscribe('/topic/force-no-edit', (message) => {
                    console.log('Received message:', message.body);
                    const parsed = JSON.parse(message.body);

                    const competition_id = parsed.competition_id;
                    const discipline_id = parsed.discipline_id;
                    const age_group_id = parsed.age_group_id;
                    const locked = parsed.locked

                    const storage_competition_id = Number(sessionStorage.getItem("competition_id"));
                    const storage_discipline_id = Number(sessionStorage.getItem("discipline_id"));
                    const storage_age_group_id = Number(sessionStorage.getItem("age_group_id"));

                    if (!storage_competition_id || !storage_discipline_id || !storage_age_group_id) {
                        console.log("Не все id сохранены в localStorage");
                        return;
                    }

                    if (auth.type === "token") return;

                    if (competition_id === storage_competition_id &&
                        discipline_id === storage_discipline_id &&
                        age_group_id === storage_age_group_id) {

                        console.log('This message is for me — showing NoEdit');
                        noEdit.open(locked);
                    }
                });
            };

            stompClient.onStompError = (frame) => {
                console.error('STOMP error:', frame.headers.message);
            };
        }

        return () => {
            stompClient.deactivate().then();
        };
    }, [auth.loading, auth.hash_error.isError, noEdit]);


    useEffect(() => {
        const getVersion = () => {
            let result =
                TableServices.getVersion(3);
            result.then(res => setVersion(res?.data?.version));
        }
        getVersion();
    }, []);

    useEffect(() => {
        if(lang) {
            setLanguage(lang)
        } else (
            setLanguage('ru')
        )
        if (isHaveHash) {
            const setHash = async () => {
                await auth.setHash(locationHash[1])
            }
            setHash()

        } else {
            const getToken = () => {
                auth.getToken()
            }
            getToken()
        }


    }, [])

    useEffect(() => {
        if (locationHash.length === 1 && locationHash[0] === '') return
        if ((locationHash.length === 1 || locationHash[0] !== '?app') && !lang) {
            navigate('/')
            window.history.pushState("", document.title, window.location.pathname
                + window.location.search);
        }
    }, [])

    if (auth.loading) {
        return null
    }

    if (auth.hash_error.isError) {
        return <div>

            <Skeleton variant="rounded" width={'100%'} height={200} sx={{marginTop: '24px'}}/>
            <Skeleton variant="rounded" width={'100%'} height={300} sx={{marginTop: '24px'}}/>

            <Modal
                open={auth.hash_error.isError}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {t("error")}
                    </Typography>
                    <Typography id="modal-modal-description" sx={{mt: 2}}>
                        {auth.hash_error.textError}
                    </Typography>
                </Box>
            </Modal>
        </div>
    }
    return (
        <div className="App">
            <div className="version">{version}</div>
            <ToastContainer/>

            <Container>
                <Router/>
                <AppModal visible={noEdit.isOpen} setVisible={noEdit.close}>
                    <NoEdit
                        location={location}
                        navigate_page={navigate}
                        visible={noEdit.isOpen}
                    />
                </AppModal>
            </Container>
        </div>
    );
})

export default App;
